import React from "react";
import { Apple } from "lucide-react";

// Live store URLs. Flip to the real URL when each store listing goes live;
// null here keeps the corresponding CTA in a polished "Coming soon" state.
export const STORE_URLS = {
    ios: "https://apps.apple.com/us/app/betweenus-conflict-resolution/id6762560908",
    android:
        "https://play.google.com/store/apps/details?id=com.betweenushelp.com",
};

export function AppStoreButton({
    variant = "ios",
    className = "",
    testId,
    compact = false,
}) {
    const isIos = variant === "ios";
    const label = isIos ? "Download on the" : "Get it on";
    const store = isIos ? "App Store" : "Google Play";
    const href = STORE_URLS[variant];
    const isLive = Boolean(href);

    const sharedClasses = `group inline-flex items-center gap-3 ${
        compact ? "h-[48px] px-4" : "h-[54px] px-5"
    } rounded-[14px] bg-[var(--brand-ink)] text-[var(--brand-paper)] hover:bg-black active:scale-[0.98] transition-[transform,background-color,box-shadow] duration-200 shadow-[0_10px_24px_rgba(14,27,42,0.16)] hover:shadow-[0_16px_40px_rgba(14,27,42,0.22)] ring-focus ${
        !isLive ? "opacity-90 cursor-not-allowed" : ""
    } ${className}`;

    const inner = (
        <>
            <span className="shrink-0">
                {isIos ? (
                    <Apple size={22} strokeWidth={1.6} />
                ) : (
                    <PlayIcon />
                )}
            </span>
            <span className="flex flex-col items-start leading-tight">
                <span className="text-[10px] uppercase tracking-[0.14em] text-[rgba(246,241,231,0.7)] font-medium">
                    {isLive ? label : "Coming soon"}
                </span>
                <span className="text-[15px] font-semibold tracking-[-0.01em]">
                    {store}
                </span>
            </span>
        </>
    );

    if (isLive) {
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testId || `appstore-${variant}-button`}
                aria-label={`${label} ${store} — opens in a new tab`}
                className={sharedClasses}
            >
                {inner}
            </a>
        );
    }

    return (
        <button
            type="button"
            disabled
            aria-disabled="true"
            data-testid={testId || `appstore-${variant}-button`}
            aria-label={`${store} — coming soon`}
            className={sharedClasses}
        >
            {inner}
        </button>
    );
}

function PlayIcon() {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M4.5 3.2c-.4.3-.7.8-.7 1.5v14.6c0 .7.3 1.2.7 1.5l8.3-8.8-8.3-8.8Z"
                fill="#5FB0AE"
            />
            <path
                d="m12.8 12 2.9-3.1 4.3 2.5c.9.5.9 1.6 0 2.1l-4.3 2.5L12.8 12Z"
                fill="#DAA520"
            />
            <path
                d="m4.5 3.2 8.3 8.8 2.9-3.1L6.3 3.6c-.7-.4-1.3-.5-1.8-.4Z"
                fill="#308C8A"
            />
            <path
                d="m4.5 20.8 8.3-8.8 2.9 3.1-9.4 5.3c-.7.4-1.3.5-1.8.4Z"
                fill="#1A3A6C"
            />
        </svg>
    );
}

export default AppStoreButton;
